module.exports = _.clamp;


//////////////////
// WEBPACK FOOTER
// external "_.clamp"
// module id = 1042
// module chunks = full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile dashboard/dashboard business-manager/video-library-page widget/widget